<div class="profileform-wrapper">
  <form class="profile-form" id="profile-form" [formGroup]="userForm">
    <div class="field-wrap">
      <div class="form-outline mb-3">
        <label class="form-label">First Name</label>
        <input type="text" id="firstName" formControlName="firstName" class="form-control" />
        <div class="error"></div>
      </div>
      <div class="form-outline mb-3">
        <label class="form-label">Last Name</label>
        <input type="text" id="lastName" formControlName="lastName" class="form-control" />
        <div class="error"></div>
      </div>
      <div class="form-outline mb-3">
        <label class="form-label">Email</label>
        <input type="email" id="email" formControlName="email" class="form-control" />
        <div class="error"></div>
      </div>
      <div class="form-outline mb-3">
        <label class="form-label">Phone</label>
        <input type="tel" id="phone" formControlName="mobile" class="form-control" />
        <div class="error"></div>
      </div>
      <div class="form-outline mb-3">
        <label class="form-label">Country</label>
        <input type="text" id="country" formControlName="country" class="form-control" />
        <div class="error"></div>
      </div>
      <div class="form-outline mb-3">
        <label class="form-label">Company</label>
        <input type="text" id="company" formControlName="company" class="form-control" />
        <div class="error"></div>
      </div>
      <div class="form-outline mb-3">
        <label class="form-label">GSTIN</label>
        <input type="text" formControlName="gstin" class="form-control" />
        <div *ngIf="userForm.controls['gstin'].touched && userForm.controls['gstin'].invalid" class="alert alert-danger form-danger error" role="alert">
          <span *ngIf="userForm?.controls['gstin']?.errors?.maxlength">Please enter only 15 character long GSTIN.</span>
          <span *ngIf="userForm?.controls['gstin']?.errors?.minlength">Please enter a 15 character long GSTIN.</span>
        </div>
      </div>
      <div class="form-outline mb-3">
        <label class="form-label">Password</label>
        <input type="password" [disabled]="true" numbersOnly [value]="12345678" class="form-control" />
        <div class="error"></div>
        <span class="text-right" (click)="changePassword()"><a class="link-text">Change Password</a></span>
      </div>
    </div>
    <button type="submit" (click)="updateUser()" [disabled]="!userForm.valid || !userForm.dirty" class="btn btn-dark-blue-bg">
      <svg width="14" height="10" viewBox="0 0 14 10" fill="none" xmlns="http://www.w3.org/2000/svg">
        <path d="M13.7733 0.326558C13.4693 0.0239599 12.9751 0.0239599 12.6711 0.326558L4.92593 8.03604L1.3289 4.45559C1.0249 4.15299 0.530657 4.15299 0.226657 4.45559C-0.0755523 4.75641 -0.0755525 5.24281 0.226657 5.54363L4.37481 9.67266C4.67881 9.97526 5.17305 9.97526 5.47705 9.67266L13.7733 1.4146C14.0756 1.11378 14.0756 0.627375 13.7733 0.326558Z" fill="white"/>
      </svg>  
      Update Details
    </button>
  </form>
</div>
